import { render, staticRenderFns } from "./login.vue?vue&type=template&id=ad678c7e"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/vercel/path0/components/ui/img.vue').default,UserLinks: require('/vercel/path0/components/userLinks.vue').default,LoginModal: require('/vercel/path0/components/loginModal.vue').default})
